import { hashFunc } from "@readai/common/utils";

const COLOR_PAIRS = [
  { bgcolor: "bg.avatar.themePink", color: "text.avatar.themePink" },
  { bgcolor: "bg.avatar.themeRed", color: "text.avatar.themeRed" },
  { bgcolor: "bg.avatar.themeYellow", color: "text.avatar.themeYellow" },
  { bgcolor: "bg.avatar.themeRedorange", color: "text.avatar.themeRedorange" },
  { bgcolor: "bg.avatar.themeOrange", color: "text.avatar.themeOrange" },
  {
    bgcolor: "bg.avatar.themeYellowgreen",
    color: "text.avatar.themeYellowgreen",
  },
  { bgcolor: "bg.avatar.themeGreen", color: "text.avatar.themeGreen" },
  { bgcolor: "bg.avatar.themeTeal", color: "text.avatar.themeTeal" },
  { bgcolor: "bg.avatar.themeBlue", color: "text.avatar.themeBlue" },
  { bgcolor: "bg.avatar.themeIndigo", color: "text.avatar.themeIndigo" },
  { bgcolor: "bg.avatar.themePurple", color: "text.avatar.themePurple" },
  { bgcolor: "bg.avatar.themeMagenta", color: "text.avatar.themeMagenta" },
];

interface AvatarSx {
  bgcolor: string;
  color: string;
}

export const getAvatarSx = (
  input?: string,
  colors: AvatarSx[] = COLOR_PAIRS,
) => {
  if (!input?.length) return {};
  return hashFunc(input, colors);
};
